import remove from 'lodash/remove';
import { getField, updateField } from 'vuex-map-fields';
import { createRegistration } from '../api/registration';
import { pushGTM } from '../../../helpers/gtm';

export const trophyChallengeModule = {
    namespaced: true,
    state:      {
        registration: null,
        form:        {
            data:       {
                executionCompany: null,
                designer: null,
                architect: null,
                generalContractor: null,
                city: null,
                project:   {
                    name:        null,
                    description: null,
                },
                files:     [],
                rules:     false
            },
            errors:     [],
            processing: false,
        },
    },
    getters:    {
        getField,
        form:        (state) => {
            return state.form.data;
        },
        registration: (state) => {
            return state.registration;
        },
        processing:  (state) => {
            return state.form.processing;
        },
        errors:      (state) => {
            return state.form.errors;
        },
        files:       (state, getters) => {
            let { files } = getters.form;
            return files;
        }
    },
    actions:    {
        createRegistration({ commit }, data) {
            commit('registrationProcessing', true);
            commit('registrationErrors', []);
            return createRegistration(data)
            .then((data) => {
                commit('registration', data);
                pushGTM('Contest a new registration', 'Rekonstrukční výzva');
            })
            .catch((e) => commit('registrationErrors', [{
                msg:   e.message || 'Registraci se nepodařilo vytvořit, zkuste to, prosím, znovu.',
                index: -1
            }])).finally(() => commit('registrationProcessing', false))
        },
        setErrors({ commit }, errors) {
            commit('registrationErrors', errors);
        },
        setFile({ commit, getters }, data) {
            let files = getters.files;
            files = remove(files, (file) => file.type !== data.type);
            files.push(data);

            commit('files', files);
        }
    },
    mutations:  {
        updateField,
        registrationErrors(state, errors) {
            state.form.errors = errors;
        },
        registrationProcessing(state, status) {
            state.form.processing = status;
        },
        registration(state, data) {
            state.registration = data;
        },
        files(state, files) {
            state.form.data.files = files;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/trophy-challenge/store/index.js